import React from "react";
import ReactDOM from "react-dom";
import {
  BrowserRouter as Router,
  Route,
  Switch,
} from "react-router-dom";

import "./style.css";
import Home from "./views/home";
import Header from "./views/header";
import NotFound from "./views/not-found";
import Galerie from "./views/galerie";

import Maison from "./views/maison";
import Grange from "./views/grange";
import Etable from "./views/etable";

import Admin from "./admin";

import ActivitesSurPlace from './views/activitesSurPlace';
import ActivitesExterieures from './views/activitesExterieures';

import ScrollToTop from "./ScrollToTop";
import IconSprite from "./components/IconSprite";


const App = () => {
  return (
    <Router>
      <IconSprite />
      <Header />

      <ScrollToTop />
      <Switch>
        
        <Route exact path="/" component={Home} />
        <Route exact path="/galerie" component={Galerie} />
        <Route exact path="/maison" component={Maison} />
        <Route exact path="/grange" component={Grange} />
        <Route exact path="/etable" component={Etable} />

        {/* ICI -> on passe en component={}, pas element={} */}
        <Route exact path="/activites-hameau" component={ActivitesSurPlace} />
        <Route exact path="/activites-exterieur" component={ActivitesExterieures} />

        <Route exact path="/admin" component={Admin} />

        {/* route 404 */}
        <Route component={NotFound} />
      </Switch>
    </Router>
  );
};

ReactDOM.render(<App />, document.getElementById("app"));
